import { parsePostLanguage } from "@/lib/post-language";
import type { TaxonomyLandingKind } from "@/lib/taxonomy-landing";
import type { PostLanguage } from "@/types/post";

// I segmenti delle landing restano identici nelle due lingue (come
// /organizzazione): cambia solo lo slug, che e per-lingua.
export const TAG_LANDING_SEGMENT = "tag";
export const COUNTRY_LANDING_SEGMENT = "paese";
export const COMUNICATI_SEGMENT = "comunicati";
export const WIKI_SEGMENT = "wiki";
export const ORGANIZZAZIONE_SEGMENT = "organizzazione";
// Non "dispatch": quella e' gia' la vista wire del feed.
export const DISPACCI_SEGMENT = "dispacci";

export function getFeedPath(language: PostLanguage): string {
  return `/${language}`;
}

export function getFeedPagePath(language: PostLanguage, page: number): string {
  return page <= 1
    ? getFeedPath(language)
    : `${getFeedPath(language)}/page/${encodeURIComponent(String(page))}`;
}

export function getFeedXmlPath(language: PostLanguage): string {
  return `${getFeedPath(language)}/feed.xml`;
}

export function getPostPath(language: PostLanguage, postSlug: string): string {
  return `${getFeedPath(language)}/posts/${encodeURIComponent(postSlug)}`;
}

export function getComunicatiPath(language: PostLanguage): string {
  return `${getFeedPath(language)}/${COMUNICATI_SEGMENT}`;
}

// «Tutti gli articoli»: i TX con almeno un articolo allegato tipizzato.
export function getDispacciPath(language: PostLanguage): string {
  return `${getFeedPath(language)}/${DISPACCI_SEGMENT}`;
}

export function getArticleKindLandingPath(language: PostLanguage, slug: string): string {
  return `${getDispacciPath(language)}/${encodeURIComponent(slug)}`;
}

export function getWikiPath(language: PostLanguage): string {
  return `${getFeedPath(language)}/${WIKI_SEGMENT}`;
}

export function getWikiPersonPath(language: PostLanguage, slug: string): string {
  return `${getWikiPath(language)}/${encodeURIComponent(slug)}`;
}

export function getOrganizzazionePath(language: PostLanguage): string {
  return `${getFeedPath(language)}/${ORGANIZZAZIONE_SEGMENT}`;
}

// Pagina delle fonti (Radio, Telex, Rete Nation, ...), sotto «Argomenti».
export function getSourcesIndexPath(language: PostLanguage): string {
  return `${getFeedPath(language)}/fonti`;
}

// Indice di tutti i tag («Argomenti»): ogni voce porta alla sua landing.
export function getTagIndexPath(language: PostLanguage): string {
  return `${getFeedPath(language)}/${TAG_LANDING_SEGMENT}`;
}

export function getTagLandingPath(language: PostLanguage, slug: string): string {
  return `${getFeedPath(language)}/${TAG_LANDING_SEGMENT}/${encodeURIComponent(slug)}`;
}

export function getCountryLandingPath(language: PostLanguage, slug: string): string {
  return `${getFeedPath(language)}/${COUNTRY_LANDING_SEGMENT}/${encodeURIComponent(slug)}`;
}

export function getTaxonomyLandingPath(
  kind: TaxonomyLandingKind,
  language: PostLanguage,
  slug: string,
): string {
  return kind === "tag"
    ? getTagLandingPath(language, slug)
    : getCountryLandingPath(language, slug);
}

export function parsePostLanguageFromPathname(pathname: string): PostLanguage | null {
  const [firstSegment] = pathname.split("/").filter(Boolean);
  return parsePostLanguage(firstSegment);
}
